<script>
    import { getContext } from 'svelte';

    export let dataKey;
    export let projection;
    export let tooltip;
    const radius = 5;

    const { pois } = getContext(dataKey);
    $: coords = $pois.map((s) => projection([s.long, s.lat]));
</script>

<g>
    {#each coords as c, i}
        <circle
            cx={c[0]}
            cy={c[1]}
            r={radius}
            opacity="1"
            fill="red"
            on:mouseenter={(e) => {
                $tooltip.start(e, $pois[i], true);
            }}
            on:mouseleave={() => {
                $tooltip.stop();
            }}
        />
    {/each}
</g>
